module.exports = {
  // Applies the same box-sizing on all content and root
  boxSizingMixin(boxSizing) {
    return {
      boxSizing,
      '*': {
        boxSizing,
      },
    };
  },

  // Sets color of an input placeholder
  // TODO: remove this polyfill, as ::placeholder falls under our supported browser version range
  placeholderMixin(color) {
    return {
      '&::-webkit-input-placeholder': {
        color,
      },
      '&:-moz-placeholder': {
        color,
      },
      '&::-moz-placeholder': {
        color,
      },
      '&:-ms-input-placeholder': {
        color: `${color} !important`,
      },
    };
  },

  // Sets the border radius
  borderRadiusMixin(borderRadius) {
    return {
      borderRadius,
      '&:-webkit-autofill': {
        borderRadius,
      },
    };
  },
};
